import { useState } from 'react';
import { generateId } from '../lib/utils';
import type { Toast } from '../components/ui/Toast';

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const addToast = (toast: Omit<Toast, 'id'>) => {
    const newToast = { ...toast, id: generateId() };
    setToasts(prev => [...prev, newToast]);
    return newToast.id;
  };

  const removeToast = (id: string) => {
    setToasts(prev => prev.filter(toast => toast.id !== id));
  };

  const success = (message: string, duration?: number) => {
    return addToast({ message, type: 'success', duration });
  };

  const error = (message: string, duration?: number) => {
    return addToast({ message, type: 'error', duration });
  };

  const info = (message: string, duration?: number) => {
    return addToast({ message, type: 'info', duration });
  };

  return {
    toasts,
    addToast,
    removeToast,
    success,
    error,
    info,
  };
}